import { inject, observer } from "mobx-react";
import React, { FC, Fragment, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "recompose";

import { KnownLocale } from "nvent-web/i18n";
import AppStore from "nvent-web/stores/App";

import style from "./Offers.module.scss";
import { RussianSmartBandOffer } from "./RussianSmartBandOffer";

interface OffersPropsInner {
  app: AppStore;
}

interface Offer {
  imgUrl?: string;
  url?: string;
  content?: ReactNode;
}

type Offers = { [K in KnownLocale]?: Offer[] };

const polishOffers: Offer[] = [];

const swedishOffers = [
  {
    imgUrl: require("nvent-web/assets/CertifiedProOffers/offer-sv-1.png"),
  },
];

const russianOffers = [
  {
    content: <RussianSmartBandOffer />,
  },
];

const offers: Offers = {
  pl: polishOffers,
  sv: swedishOffers,
  ru: russianOffers,
};

const OffersInner: FC<OffersPropsInner> = ({ app: { locale } }) => {
  const offersForLocale = offers[locale] || [];

  if (offersForLocale.length === 0) {
    return <FormattedMessage id="certifiedPage.certified.activePromotions.empty" />;
  }
  return (
    <div className={style.offersContainer}>
      {offersForLocale.map(({ imgUrl, url, content }) => {
        if (content) {
          return content;
        }

        const ImgWrapper = url
          ? ({ children }: { children: ReactNode }) => (
              <a href={url} rel="noopener noreferrer" target="_blank">
                {children}
              </a>
            )
          : Fragment;

        return (
          <div key={imgUrl} className={style.imageWrapper}>
            <ImgWrapper>
              <img src={imgUrl} className={style.offer} alt="special offer" />
            </ImgWrapper>
          </div>
        );
      })}
    </div>
  );
};

export const Offers = compose<OffersPropsInner, {}>(
  inject("app"),
  observer
)(OffersInner);
